import React, { useState } from "react";
import Navbar3 from "./Navbar3";
import Footer from "./Footer";

function TrainRentalPricing() {
  const [pricingType, setPricingType] = useState("train");

  const standardPricing = [
    {
      title: "Half Day (4 hrs)",
      price: "$1500",
      description: "Includes train and conductor",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Full Day (8 hrs)",
      price: "$2800",
      description: "Includes train and conductor",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Deluxe Package",
      price: "$95/hr",
      description:
        "Includes extra attendant and Train Station tent serving as loading station",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    }
  ];

  const holidayPricing = [
    {
      title: "Half Day (4 hrs)",
      price: "$1900",
      description: "Includes train and conductor",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Full Day (8 hrs)",
      price: "$3800",
      description: "Includes train and conductor",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    }
  ];

  const bumperCarPricing = [
    {
      title: "Bumper Car Express",
      price: "$1,295",
      description: "2 Hours",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Bumper Car Party",
      price: "$1,595",
      description: "3 Hours",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Bumper Car Experience",
      price: "$1,895",
      description: "4 Hours",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Festival Package",
      price: "$2,495",
      description: "Up to 6 Hours",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    },
    {
      title: "Full-Day Event",
      price: "$2,995",
      description: "Up to 8 Hours",
      cta: 'Text “Rental” to',
      phone: "210-859-9677"
    }
  ];

  return (
    <>
    <Navbar3 />
    <div className="event-experience-image">
        <img
          src="/s3/train-car-rental-banner.jpg"
          alt="ADS Flag Football"
        />
      </div>
      <section className="train-rental-pricing py-5">
        <div className="container">

          <div className="row justify-content-center mb-5">
            <div className="col-auto">
              <div
                className="btn-group"
                role="group"
                aria-label="Rental pricing type"
              >
                <button
                  type="button"
                  className={
                    pricingType === "train"
                      ? "btn btn-secondary"
                      : "btn btn-outline-secondary"
                  }
                  onClick={() =>
                    setPricingType("train")
                  }
                >
                  TRAIN RENTALS
                </button>

                <button
                  type="button"
                  className={
                    pricingType === "bumperCars"
                      ? "btn btn-secondary"
                      : "btn btn-outline-secondary"
                  }
                  onClick={() =>
                    setPricingType("bumperCars")
                  }
                >
                  BUMPER CAR RENTALS
                </button>
              </div>
            </div>
          </div>

          {pricingType === "train" && (
            <>
              <div className="row">
                <div className="col-12 text-center">
                  <h2 className="train-rental-pricing__title futuraPTMedium">
                    Train Rental - Standard Pricing
                  </h2>
                </div>
              </div>

              <div className="row g-4 justify-content-center mb-5">
                {standardPricing.map((plan) => (
                  <div
                    className="col-12 col-md-6 col-xl-4 d-flex"
                    key={plan.title}
                  >
                    <div className="train-rental-pricing-card">
                      <h3 className="train-rental-pricing-card__title futuraPTMedium">
                        {plan.title}
                      </h3>

                      <div className="train-rental-pricing-card__price futuraPTBold">
                        {plan.price}
                      </div>

                      <p className="train-rental-pricing-card__description futuraPTBook">
                        {plan.description}
                      </p>

                      <div className="train-rental-pricing-card__cta futuraPTMedium">
                        {plan.cta}
                        <br />

                        <a href={`sms:${plan.phone}`}>
                          {plan.phone}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col-12 text-center">
                  <h2 className="train-rental-pricing__title futuraPTMedium">
                    Holiday Pricing
                  </h2>

                  <p className="train-rental-pricing__holiday-copy futuraPTBook">
                    We love making the holidays extra special!
                    Our train is decked out with festive decorations
                    to bring even more excitement and holiday spirit
                    to your celebration. Because the holiday season
                    is one of our busiest times of the year, special
                    holiday rental pricing applies to select dates
                    and events. Holiday pricing is as follows:
                  </p>
                </div>
              </div>

              <div className="row g-4 justify-content-center mb-5">
                {holidayPricing.map((plan) => (
                  <div
                    className="col-12 col-md-6 col-xl-4 d-flex"
                    key={plan.title}
                  >
                    <div className="train-rental-pricing-card">
                      <h3 className="train-rental-pricing-card__title futuraPTMedium">
                        {plan.title}
                      </h3>

                      <div className="train-rental-pricing-card__price futuraPTBold">
                        {plan.price}
                      </div>

                      <p className="train-rental-pricing-card__description futuraPTBook">
                        {plan.description}
                      </p>

                      <div className="train-rental-pricing-card__cta futuraPTMedium">
                        {plan.cta}
                        <br />

                        <a href={`sms:${plan.phone}`}>
                          {plan.phone}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row justify-content-center">
                <div className="col-12 col-lg-8 text-center">
                  <div className="train-rental-pricing__holiday-dates futuraPTBook">
                    <p>
                      <strong>Easter:</strong>{" "}
                      April 1st-April 30th
                    </p>

                    <p>
                      <strong>4th of July:</strong>{" "}
                      June 15th-July 15th
                    </p>

                    <p>
                      <strong>Halloween:</strong>{" "}
                      October 1st - October 31st
                    </p>

                    <p>
                      <strong>Winter:</strong>{" "}
                      November 15th-January 5th
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}

          {pricingType === "bumperCars" && (
            <>
              <div className="row">
                <div className="col-12 text-center">
                  <h2 className="train-rental-pricing__title futuraPTMedium">
                    Bumper Car Rental Pricing
                  </h2>
                </div>
              </div>

              <div className="row g-4 justify-content-center">
                {bumperCarPricing.map((plan) => (
                  <div
                    className="col-12 col-md-6 col-xl-4 d-flex"
                    key={plan.title}
                  >
                    <div className="train-rental-pricing-card">
                      <h3 className="train-rental-pricing-card__title futuraPTMedium">
                        {plan.title}
                      </h3>

                      <div className="train-rental-pricing-card__price futuraPTBold">
                        {plan.price}
                      </div>

                      <p className="train-rental-pricing-card__description futuraPTBook">
                        {plan.description}
                      </p>

                      <div className="train-rental-pricing-card__cta futuraPTMedium">
                        {plan.cta}
                        <br />

                        <a href={`sms:${plan.phone}`}>
                          {plan.phone}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

        </div>
      </section>
      <Footer />
    </>
  );
}

export default TrainRentalPricing;